import React from 'react';
import { Card, Heading } from '@printdeal/ui-library';
import { Link as GatsbyLink } from 'gatsby';
import { FormattedMessage } from 'react-intl';
import type { RelatedProduct } from './HeroSearchChat';
import ContentfulCardImage from '../../ContentfulCardImage';

interface Props {
  products: RelatedProduct[];
}

export const RelatedProducts: React.FC<Props> = ({ products }) => (
  <div className="pd-col-start-1 pd-row-start-1 pd-py-8">
    {/* eslint-disable-next-line tailwindcss/no-custom-classname */}
    <div className="pd-animation-fade-in-scale pd-mb-2 pd-self-start pd-font-normal">
      <Heading variant="display" size="3">
        <FormattedMessage
          id="impressto.homepage.hero.relatedProducts"
          defaultMessage="Related products"
        />
      </Heading>
    </div>
    <div className="pd-grid pd-grid-cols-2 pd-gap-4">
      {products.map((product) => (
        <Card
          key={product.id}
          image={(
            <ContentfulCardImage
              src={product.image}
              priority
              alt={product.title}
            />
            )}
          title={product.title}
          link={<GatsbyLink to={product.slug} />}
          // eslint-disable-next-line tailwindcss/no-custom-classname
          className="pd-animation-fade-in-scale pd-h-full pd-cursor-pointer"
          variant="square"
          size="sm"
        />
      ))}
    </div>
  </div>
);
